export interface ScoringConfig {
  /** base points by number of terms, e.g. { 1: 10, 2: 20, 3: 35 } */
  base: Record<string, number>;
  streakBonus: number;
  streakCap?: number;
}

/** Points for a correct answer given the streak *after* this answer (1 = first in a row). */
export function pointsFor(terms: number, streak: number, cfg: ScoringConfig): number {
  const base = cfg.base[String(terms)] ?? cfg.base[String(Object.keys(cfg.base).length)] ?? 10;
  return base + cfg.streakBonus * Math.min(streak, cfg.streakCap ?? 10);
}
